import { z } from "zod";

const optionalId = z
  .union([z.string().min(1).max(100), z.literal(""), z.null()])
  .optional()
  .transform((value) => (value ? value : null));

export const maintenanceCreateSchema = z.object({
  assetId: z.string().min(1).max(100),
  description: z.string().trim().min(2, "请描述故障或维修事项").max(1000),
  costYuan: z.coerce.number().min(0).max(10_000_000).default(0),
  vendor: z.string().trim().max(200).optional().nullable(),
  sentAt: z.string().datetime({ offset: true }).optional().nullable(),
  expectedAt: z.string().datetime({ offset: true }).optional().nullable(),
});

export const maintenanceCostDecisionSchema = z.object({
  decision: z.enum(["approve", "reject"]),
  comment: z.string().trim().max(500).optional().nullable(),
});

export const maintenancePartSchema = z.object({
  materialId: optionalId,
  partName: z.string().trim().min(1).max(200),
  quantity: z.coerce.number().int().min(1).max(1000),
  unitCostYuan: z.coerce.number().min(0).max(10_000_000).default(0),
});

export const maintenanceCompleteSchema = z.object({
  result: z.string().trim().min(2, "请填写维修结果").max(1000),
  completedAt: z.string().datetime({ offset: true }).optional().nullable(),
  parts: z.array(maintenancePartSchema).max(50).optional().default([]),
});

export const maintenanceCancelSchema = z.object({
  reason: z.string().trim().min(1, "请填写取消原因").max(500),
});
